import React, {Component} from 'react'
import {Disc, X, Circle} from 'react-feather'
import classnames from 'classnames'
import {IMAGE} from '../../../../configs/app-configs'
import {useDispatch} from 'react-redux'
import {goBackHomePage} from '../../../../redux/actions/navbar/Index'

const SidebarHeader = (props) => {

  const {
    toggleSidebarMenu,
    activeTheme,
    collapsed,
    toggle,
    sidebarVisibility,
    menuShadow
  } = props

  const dispatch = useDispatch();


  const onClickHome = () => {
    dispatch(goBackHomePage())
  }


    return (
      <div className='navbar-header'>
        <ul className='nav navbar-nav flex-row'>
          <li className='nav-item my-auto mr-auto cursor-pointer' onClick={onClickHome}>
              <img
                className='img-fluid logo-img'
                src={IMAGE.LOGO_NO_TEXT}
                alt='logo'
              />
              <img
                  className='img-fluid logo-text'
                  src={IMAGE.LOGO_TEXT}
                  alt='logo'
                />
          </li>
          <li className='nav-item nav-toggle'>
            <div className='nav-link modern-nav-toggle'>
              {collapsed === false ? (
                <Disc
                  onClick={() => {
                    toggleSidebarMenu(true)
                    toggle()
                  }}
                  className={classnames(
                    'toggle-icon icon-x d-none d-xl-block font-medium-4',
                    {
                      'text-primary': activeTheme === 'primary',
                      'text-success': activeTheme === 'success',
                      'text-danger': activeTheme === 'danger',
                      'text-info': activeTheme === 'info',
                      'text-warning': activeTheme === 'warning',
                      'text-dark': activeTheme === 'dark'
                    }
                  )}
                  size={20}
                  data-tour='toggle-icon'
                />
              ) : (
                <Circle
                  onClick={() => {
                    toggleSidebarMenu(false)
                    toggle()
                  }}
                  className={classnames(
                    'toggle-icon icon-x d-none d-xl-block font-medium-4',
                    {
                      'text-primary': activeTheme === 'primary',
                      'text-success': activeTheme === 'success',
                      'text-danger': activeTheme === 'danger',
                      'text-info': activeTheme === 'info',
                      'text-warning': activeTheme === 'warning',
                      'text-dark': activeTheme === 'dark'
                    }
                  )}
                  size={20}
                />
              )}
              <X
                onClick={sidebarVisibility}
                className={classnames(
                  'toggle-icon icon-x d-block d-xl-none font-medium-4',
                  {
                    'text-primary': activeTheme === 'primary',
                    'text-success': activeTheme === 'success',
                    'text-danger': activeTheme === 'danger',
                    'text-info': activeTheme === 'info',
                    'text-warning': activeTheme === 'warning',
                    'text-dark': activeTheme === 'dark'
                  }
                )}
                size={20}
              />
            </div>
          </li>
        </ul>
        <div
          className={classnames('shadow-bottom', {
            'd-none': menuShadow === false
          })}
        />
      </div>
    )

}

export default SidebarHeader
